import React from "react";
import { Card, CardBody, CardTitle, ListGroup, ListGroupItem } from "reactstrap";
import { useGetProjectMembersQuery, usePingQuery } from "../../../../openapi";

export const IntegrationsHealthChecker: React.FC = () => {
  // const {
  //   data: azureFunctionsAPIPing,
  //   error: azureFunctionsAPIPingError,
  //   isLoading: azureFunctionsAPIPingLoading,
  //   isSuccess: azureFunctionsAPIPingSuccess,
  // } = usePingMCappsAzureFunctionsQuery();

  const { data: pingTrpc, error: trpcPingError, isSuccess: trpcSuccess } = usePingQuery();

  const listItems = [
    // {
    //   name: "Azure Functions API",
    //   isSuccess: azureFunctionsAPIPingError == null && azureFunctionsAPIPingSuccess === true,
    // },
    {
      name: "TRPC API",
      isSuccess: trpcPingError == null && trpcSuccess === true,
    },
  ];



  console.log(pingTrpc?.ping);

  return (
    <Card>
      <CardBody>
        <CardTitle tag="h3">Integrationer</CardTitle>
        <ListGroup>
          {listItems.map((item) => (
            <ListGroupItem color={item.isSuccess ? "success" : "danger"}>{item.name}</ListGroupItem>
          ))}
        </ListGroup>
      </CardBody>
    </Card>
  );
};
